<script context="module" lang="ts">
    import { kirbyFetch } from "../../api/kirby/api"
    import { FileData } from "../../api/kirby/queries"

    const medialibCache: { [id: string]: FileData } = {}
    export async function loadMedialibEntry(id: string): Promise<FileData> {
        if (medialibCache[id]) return medialibCache[id]
        const entry = await kirbyFetch<FileData>({
            query: `file('${id}')`,
            select: FileData,
        })
        medialibCache[id] = entry
        return medialibCache[id]
    }
</script>

<script lang="ts">
    export let id: string,
        noPlaceholder: boolean = false,
        loading = true,
        fileData: FileData = null

    let entry: FileData, fileSrc: string

    async function loadFile() {
        loading = true
        entry = null
        fileSrc = null
        try {
            entry = await loadMedialibEntry(id)
            fileSrc = entry.url
        } catch (e) {
            console.error(e)
        }
        loading = false
    }

    $: if (fileData) {
        entry = fileData
        fileSrc = fileData.url
        loading = false
    } else if (id) loadFile()
</script>

{#if id || fileData}
    {#if loading}
        {#if !noPlaceholder}
            <slot name="loading" {entry} src={fileSrc} />
        {/if}
    {:else if entry}
        <slot {entry} src={fileSrc} />
    {:else if !noPlaceholder}
        <slot name="not-found" />
    {/if}
{/if}
